<template>
  <BaseCardSection title="Montáž" :is-visible="isVisible" :is-optional="true" @toggle="toggleVisibility">

    <fieldset class="row g-3" id="assemblyAllowedField" v-show="isVisible">
      <!--        <div class="row gy-2">-->
      <!--          <div class="form-group">-->
      <!--            <h5>Zvol dílce určené pro montáž:</h5>-->
      <!--            <CalculationItemsSelector :calculationItems="calculationItems"-->
      <!--                                      :caption="'assembly'"-->
      <!--                                      :selected-items="assemblyInternal.itemList" />-->
      <!--          </div>-->
      <!--        </div>-->
      <CalculationAsemblyItems :calculationItems="calculationItems"
                               v-model:max-weight-item="maxWeightItem"/>
      <div class="row gy-2">
        <WeightPeopleCount :weight="maxWeightItem"/>
        <div class="form-group col-sm-12 col-md-3" aria-disabled="false">
          <label class="form-label" for="assembly-head-count">Počet osob:</label>
          <input type="number" step="1" min="1" class="form-control" id="assembly-head-count"
                 name="assembly-head-count" v-model="assemblyInternal.headCount"
                 v-validate="{
                     rules: { required: true, min: 0 },
                     message: { required: 'Počet osob je povinný', min: 'Minimálně 0 osob' },
                     options: { showValidState: false }
                   }">
        </div>
        <div class="form-group col-sm-12 col-md-3 position-relative" aria-disabled="false">
          <label class="form-label" for="assembly-hours">Počet hodin:</label>
          <input type="number" step="1" min="1" class="form-control" id="assembly-hours" name="assembly-hours"
                 v-model="assemblyInternal.assemblyHours"
                 v-validate="{
                     rules: { required: true, min: 0 },
                     message: { required: 'Počet hodin je povinný', min: 'Minimálně 0 h' },
                     options: { showValidState: false }
                   }"
                 v-tooltip="'Do počtu hodin je nutné zahrnout i čas strávený na cestě k místu montáže.'"
                 data-tooltip-position="top"
                 data-tooltip-trigger="focus">
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label" for="max-weight-item-assembly">Nejtěžší dílec (kg)</label>
          <input type="number" class="form-control" id="max-weight-item-assembly" v-model="maxWeightItem" disabled>
        </div>

      </div>
    </fieldset>
  </BaseCardSection>
</template>

<script setup>
import {ref, watch, onMounted, defineProps, defineEmits} from 'vue';
import Assembly from "@/models/Assembly";
import CalculationAsemblyItems from "@/components/calculation/CalculationAsemblyItems.vue";
import WeightPeopleCount from "@/components/base/WeightPeopleCount.vue";
import BaseCardSection from "@/components/base/BaseCardSection.vue";

const props = defineProps(['calculationItems', 'assembly', 'cid']);
const emit = defineEmits(['update:assembly']);

const isVisible = ref(false);
const maxWeightItem = ref(0);
const assemblyInternal = ref({});

const setVisibility = (item) => {
  isVisible.value = item !== null;
};

const toggleVisibility = () => {
  isVisible.value = !isVisible.value;
  if (isVisible.value) {
    emit('update:assembly', assemblyInternal.value);
  } else {
    emit('update:assembly', null);
  }
};

// const toggleAsseblyItems = (item) => {
//   return !!item.calculationAssemblyId;
// };

watch(assemblyInternal, (newVal) => {
  if (isVisible.value) {
    emit('update:assembly', newVal);
  }
}, {deep: true, immediate: true});

onMounted(() => {
  assemblyInternal.value = props.assembly ? props.assembly : new Assembly({
    calculation_uid: props.cid,
    assembly_hours: 0,
    head_count: 0,
    itemList: [],
  });
  setVisibility(props.assembly);
});
</script>

<style scoped>
.top-15 {
  top: 15%;
}
</style>

